import { Box, Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const StepperContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export const StepperLabel = styled(Typography)({
  fontWeight: 700,
  textTransform: 'uppercase',
  letterSpacing: 0.5,
});
